import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MdDelete } from 'react-icons/md';

import {
  FormControl,
  FormField,
  FormItem,
  FormMessage
} from '../../components/ui/Form';
import { TextArea } from '../../components/ui/TextArea';
import { Palette } from '../../components/utils';
import { TECHNICIAN_NOTE_TEXTAREA_HEIGHT, formatTechnicianNoteMeta } from './technicianNotesUtils';

const TechnicianNoteForm = ({ form, index, onRemove, canRemove, disabled }) => {
  const { t } = useTranslation();
  const author = form.watch(`technician_note_items.${index}.author`);
  const date = form.watch(`technician_note_items.${index}.date`);

  return (
    <NoteCard>
      <NoteHeader>
        <NoteTitle>{t('Note')} {index + 1}</NoteTitle>
        {canRemove && !disabled && (
          <DeleteButton type="button" onClick={() => onRemove(index)}>
            <MdDelete size={20} />
            {t('Remove')}
          </DeleteButton>
        )}
      </NoteHeader>

      {(author || date) && (
        <NoteMetaText>{formatTechnicianNoteMeta(author, date)}</NoteMetaText>
      )}

      <FormField
        control={form.control}
        name={`technician_note_items.${index}.note`}
        render={({ field }) => (
          <FormItem alt>
            <FormControl>
              <TextArea
                height={TECHNICIAN_NOTE_TEXTAREA_HEIGHT}
                rows={4}
                type="text"
                placeholder={t('Add technician notes...')}
                disabled={disabled}
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </NoteCard>
  );
};

export default TechnicianNoteForm;

const DeleteButton = styled.button`
  padding: 4px;
  display: flex;
  align-items: center;
  background-color: transparent;
  border: none;
  color: ${Palette.ERROR};
  font-weight: 500;
  cursor: pointer;

  & > svg {
    margin-right: 4px;
  }

  &:hover {
    color: #c93a3a;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const NoteCard = styled.div`
  border: 1px solid #d8dbe0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 12px;
  background-color: #f8f9fa;
`;

const NoteHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

const NoteTitle = styled.p`
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${Palette.BLACK};
`;

const NoteMetaText = styled.span`
  display: block;
  font-size: 12px;
  color: #8898aa;
  margin-bottom: 8px;
`;
